<template>
    <swiper-slide>
        <v-img
            class="news-slider__image"
            :src="img_url"
            cover
        />
    </swiper-slide>
</template>

<script>
export default {
    name: 'MainSliderSlide',
    props: {
        img: String
    },
    computed: {
        img_url() {
            return window.document.location.origin + this.img
        }
    }
}
</script>
